import { ViewportScroller } from '@angular/common';
import { inject, Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class UniversitySearchScrollerService {
	private _viewportScroller = inject(ViewportScroller);

	constructor() {
		this._viewportScroller.setHistoryScrollRestoration('manual');
	}

	scroll() {
		setTimeout(() =>
			this._viewportScroller.scrollToAnchor('university-search-container'),
		);
	}

	scrollToTop() {
		this._viewportScroller.scrollToPosition([0, 0]);
	}
}
